// Pure, deterministic rules shared by the browser and Node 12. Original text is never rewritten.
function normalized(value) {
    return typeof value === 'string' ? value.normalize('NFKC')
        .replace(/[\u00ad\u034f\u061c\u180e\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufeff]/g, '')
        .replace(/\s+/g, ' ').trim() : '';
}

function words(value) {
    return (normalized(value).toLowerCase().replace(/ё/g, 'е').match(/[a-zа-я]+/g) || []).join(' ');
}

const GUIDANCE = {
    characteristic: 'Опишите конкретную работу сотрудника и как он с ней справился: качество, самостоятельность или наблюдаемый результат.',
    ktu_comment: 'Опишите конкретный поступок или результат, который объясняет выбранный КТУ.',
    explanation: 'Добавьте факты: что произошло, кто или что помешало и что вы предприняли.'
};

function validateText(value, profile, options) {
    const config = options || {};
    const text = normalized(value);
    const help = config.help || GUIDANCE[profile] || GUIDANCE.explanation;
    const issue = (code, message) => ({code, message, help});
    if (!text) return issue('empty', 'Пояснение не заполнено. Пробелы и невидимые символы не считаются ответом.');
    if (typeof value !== 'string') return issue('type', 'Введите текстовое пояснение.');
    if (value.length > (config.maxLength || 4000)) return issue('too_long', `Сократите текст до ${config.maxLength || 4000} символов.`);
    const letters = text.match(/[\p{L}]/gu) || [];
    if (!letters.length) return issue('symbols_only', 'Вместо пояснения введены только знаки, цифры или эмодзи.');
    const tokenText = words(text);
    const tokens = tokenText.split(' ').filter(Boolean);
    if (letters.length < 2 || new Set(letters.map(letter => letter.toLowerCase())).size === 1
        || /^(?:qwe|qwerty|asdf|asdfgh|zxc|йцу|йцукен|фыв|фыва|фывапр|абвгд|тест)+$/.test(tokenText.replace(/ /g, ''))
        || /^(.{1,8})\1{2,}$/u.test(letters.join('').toLowerCase())
        || tokens.length >= 3 && new Set(tokens).size === 1) {
        return issue('filler', 'Повторяющиеся буквы или слова и клавиатурные заглушки не объясняют ситуацию.');
    }
    if (/^(?:нет|да|ок|окей|норм|нормально|хорошо|плохо|не знаю|не помню|без комментариев|указано выше|см выше|то же самое|как всегда)$/.test(tokenText)) {
        return issue('generic', 'Ответ не содержит конкретного пояснения.');
    }
    if ((profile === 'characteristic' || profile === 'ktu_comment')
        && /^(?:работал|работает|работает нормально|работает хорошо|работает плохо|плохо работает|без нареканий|нет нареканий|замечаний нет|без замечаний|молодец|исполнительный|самостоятельный|водитель|прораб|итр|стаф|стафф|наемный работник|подсобный рабочий|боевая единица)$/.test(tokenText)) {
        return issue('generic_characteristic', 'Это общая оценка или название роли; по ней нельзя понять работу сотрудника.');
    }
    if (profile === 'explanation' && /^(?:(?:фото|фотографии) (?:нет|отсутствуют|отсутствует|не предоставлены)|нет фото|зазевался|забыл|не было возможности|другая причина)$/.test(tokenText)) {
        return issue('generic_explanation', 'Уточнение повторяет проблему, но не объясняет обстоятельства.');
    }
    return null;
}

function characteristicTextIssues(line, fields) {
    const result = [];
    const add = (key, label, value, profile, maxLength) => {
        // Required/optional and empty-line rules belong to the timesheet domain, not this validator.
        if (value === null || value === undefined || value === '') return;
        const issue = validateText(value, profile, {maxLength});
        if (issue) result.push(Object.assign({type: 'invalid_characteristic_text', line_id: Number(line.id),
            employee_id: line.employee_id, employee_name: line.employee_name_snapshot,
            field_key: key, field_label: label, value}, issue));
    };
    (fields || []).filter(field => field.type === 'text').forEach(field =>
        add(field.key, field.label, (line.characteristic_values || {})[field.key], 'characteristic', field.max_length));
    add('ktu_comment', 'Пояснение КТУ', line.ktu_comment, 'ktu_comment', 4000);
    return result;
}

module.exports = {normalized, words, validateText, characteristicTextIssues};
